import { locationChangeAction } from 'domain/router/redux/reduxActions';

const initLocationChangeListener = (router, dispatch) => () => {
  router.subscribe((state) => {
    const { historyAction, location } = state;

    dispatch(locationChangeAction(location, historyAction));
  });
};

export default initLocationChangeListener;
